import students_icon from '../Icons/students_icon.png'
import course_icon from '../Icons/courses_icon.png'
import enrollments_icon from '../Icons/enrollment_icon.png'
import report_icon from '../Icons/report_icon.png'
import users_icon from '../Icons/users_icon.png'
import user_icon from '../Icons/user_icon.png'
import message_icon from '../Icons/message_icon.png'
import newsletter_icon from '../Icons/newsletter_icon.png'
import contact_icon from '../Icons/contact_icon.png'
import blog_icon from '../Icons/blog_icon.png'
import addons_icon from '../Icons/addons_icon.png'
import themes_icon from '../Icons/theme_icon.png'
import settings_icon from '../Icons/settings_icon.png'
import manageprofile_icon from '../Icons/manage_profile.png'
import videocamera_icon from '../Icons/videocamera_icon.png'
import blackbox from '../Icons/black-check-box.png'
import delete_icon from '../Icons/icons8-delete-100.png'
import download_icon from '../Icons/icons8-download-24.png'
import database_icon from '../Icons/icons8-database-50.png'
import telegram_icon from '../Icons/telegram.png'
import folder_icon from '../Icons/folder.png'
import cloud_icon from '../Icons/cloud-storage.png'
import apple_icon from '../Icons/apple_key.png'
import dashboard_icon from "../Icons/ninedots_icon.png";
import director from '../Icons/director.png'
import skill from '../Icons/skill.png'
import employeeExchange from '../Icons/employment.png'

export const icons = {
  students_icon,
  dashboard_icon,
  course_icon,
  enrollments_icon,
  report_icon,
  users_icon,
  user_icon,
  message_icon,
  newsletter_icon,
  contact_icon,
  blog_icon,
  addons_icon,
  themes_icon,
  settings_icon,
  manageprofile_icon,
  videocamera_icon,
  blackbox,
  delete_icon,
  download_icon,
  database_icon,
  telegram_icon,
  folder_icon,
  cloud_icon,
  apple_icon,
  director,
  skill,
  employeeExchange
}